import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React, { useState, useEffect } from 'react';
import { node, shape, string, bool } from 'prop-types';
import { Heading } from '@tesla/design-system-react';
import styles from './styles.module.css.js';
import Navigation from './Navigation/index.js';
import getTranslation from './translation.js';
import { NAVIGATION_PAGE_STATE } from './Navigation/pages.js';

var PageWrapper = function PageWrapper(_ref) {
  var children = _ref.children,
    currentPage = _ref.currentPage,
    isChargingEnabled = _ref.isChargingEnabled,
    isCNEnv = _ref.isCNEnv,
    isContactView = _ref.isContactView,
    isLootBoxEnabled = _ref.isLootBoxEnabled,
    isPaymentMethodEnabled = _ref.isPaymentMethodEnabled,
    isProdEnv = _ref.isProdEnv,
    locale = _ref.locale,
    title = _ref.title;
  var _getTranslation = getTranslation(locale),
    translations = _getTranslation["default"];

  // using localStorage here so the nav being open or closed will persist between pages and other apps
  var _useState = useState(!!window.localStorage.getItem(NAVIGATION_PAGE_STATE)),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpenState = _useState2[1];

  // using getElementById because there is no other way to effect tds-site-header
  var headerElement = document.getElementById('tds-site-header');
  var setIsOpen = function setIsOpen(open) {
    if (headerElement && headerElement.classList) {
      if (open) {
        headerElement.classList.add('Blur');
      } else {
        headerElement.classList.remove('Blur');
      }
    }
    setIsOpenState(open);
  };
  window.localStorage.setItem(NAVIGATION_PAGE_STATE, isOpen ? NAVIGATION_PAGE_STATE : '');
  useEffect(function () {
    if (headerElement && headerElement.classList && isOpen) {
      headerElement.classList.add('Blur');
    }
    // the user just came from another page, so close the nav after the first render to play the animation
    setTimeout(function () {
      setIsOpen(false);
      window.localStorage.setItem(NAVIGATION_PAGE_STATE, '');
    }, 0);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.PageWrapper
  }, /*#__PURE__*/React.createElement("aside", {
    className: styles.Navigation
  }, /*#__PURE__*/React.createElement(Navigation, {
    currentPage: currentPage,
    isChargingEnabled: isChargingEnabled,
    isCNEnv: isCNEnv,
    isContactView: isContactView,
    isLootBoxEnabled: isLootBoxEnabled,
    isOpen: isOpen,
    isPaymentMethodEnabled: isPaymentMethodEnabled,
    isProdEnv: isProdEnv,
    locale: locale,
    setIsOpen: setIsOpen
  })), /*#__PURE__*/React.createElement("main", {
    className: "".concat(styles.Main, " ").concat(isOpen ? styles.IsOpen : ''),
    id: "main-content"
  }, /*#__PURE__*/React.createElement(Heading, {
    is: "h1"
  }, title || translations[currentPage.NAME]), children));
};
PageWrapper.propTypes = {
  children: node.isRequired,
  currentPage: shape({
    ROUTE: string,
    NAME: string,
    APP: string
  }).isRequired,
  isChargingEnabled: bool,
  isCNEnv: bool,
  isContactView: bool,
  isLootBoxEnabled: bool,
  isPaymentMethodEnabled: bool,
  isProdEnv: bool,
  locale: string,
  title: string
};
PageWrapper.defaultProps = {
  isChargingEnabled: false,
  isCNEnv: false,
  isContactView: false,
  isLootBoxEnabled: false,
  isPaymentMethodEnabled: true,
  isProdEnv: true,
  locale: 'en_US',
  title: ''
};

export { PageWrapper as default };
